const outline = (body: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:var(--ng-icon__size, 1em);height:var(--ng-icon__size, 1em);stroke-width:var(--ng-icon__stroke-width, 1.5)">${body}</svg>`;

// Tracés Lucide (licence ISC), réduits au gabarit Heroicons (3–21) à trait constant.
const fromLucide = (body: string) =>
  outline(
    `<g transform="translate(1.2 1.2) scale(0.9)" style="stroke-width:calc(var(--ng-icon__stroke-width, 1.5) / 0.9)">${body}</g>`,
  );

const CALENDAR =
  '<path d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"/>';

const DOCUMENT =
  '<path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>';

export const evaSave = outline(
  '<path d="M16.19 3H5.25A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V7.81a1.5 1.5 0 0 0-.44-1.06l-3.31-3.31A1.5 1.5 0 0 0 16.19 3Z"/><path d="M7.5 3v3.75c0 .414.336.75.75.75h6c.414 0 .75-.336.75-.75V3"/><path d="M6.75 21v-6c0-.414.336-.75.75-.75h9c.414 0 .75.336.75.75v6"/>',
);

export const evaCircle = outline('<circle cx="12" cy="12" r="9"/>');

export const evaCircleFill = outline('<circle cx="12" cy="12" r="9" fill="currentColor" stroke="none"/>');

export const evaCheckSquare = outline(
  '<path d="M6 3.75h12A2.25 2.25 0 0 1 20.25 6v12A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18V6A2.25 2.25 0 0 1 6 3.75Z"/><path d="m9 12.75 2.25 2.25L15 9.75"/>',
);

export const evaSpinner = outline('<path d="M21 12a9 9 0 1 1-9-9"/>');

// Ruban Acrobat repris de PrimeIcons pi-file-pdf (licence MIT), épaissi pour rester lisible en 16 px.
export const evaFilePdf = outline(
  `${DOCUMENT}<path fill="currentColor" stroke-width=".6" d="M13.49,14.85a3.15,3.15,0,0,1-1.31-1.66,4.44,4.44,0,0,0,.19-2A.8.8,0,0,0,10.85,11a5,5,0,0,0,.25,2.4A29,29,0,0,1,9.83,16C9.12,16.4,8.15,17,8,17.69c-.12.56.93,2,2.72-1.12a18.58,18.58,0,0,1,2.44-.72,4.72,4.72,0,0,0,2,.61.82.82,0,0,0,.62-1.38C15.36,14.65,14.11,14.77,13.49,14.85Zm-4.78,3A4.32,4.32,0,0,1,9.8,16.61C9.12,17.69,8.71,17.88,8.71,17.86Zm2.92-6.81c.26,0,.24,1.15.06,1.46A3.07,3.07,0,0,1,11.63,11.05Zm-.87,4.88A14.76,14.76,0,0,0,11.64,14a3.88,3.88,0,0,0,1.08,1.26A12.35,12.35,0,0,0,10.76,15.93Zm4.7-.18s-.18.22-1.33-.28C15.38,15.38,15.59,15.67,15.46,15.75Z"/>`,
);

export const evaFileExcel = outline(`${DOCUMENT}<path d="M8.25 12.75h7.5V18h-7.5zM8.25 15.375h7.5M12 12.75V18"/>`);

export const evaPercent = outline(
  '<path d="m18.75 5.25-13.5 13.5"/><circle cx="7.125" cy="7.125" r="2.25"/><circle cx="16.875" cy="16.875" r="2.25"/>',
);

export const evaSitemap = outline(
  '<rect x="9" y="3" width="6" height="4.5" rx="1.125"/><rect x="3" y="16.5" width="6" height="4.5" rx="1.125"/><rect x="15" y="16.5" width="6" height="4.5" rx="1.125"/><path d="M12 7.5V12m-6 4.5v-3.375c0-.621.504-1.125 1.125-1.125h9.75c.621 0 1.125.504 1.125 1.125V16.5"/>',
);

export const evaCompass = outline(
  '<circle cx="12" cy="12" r="9"/><path d="m15.75 8.25-2.25 5.25-5.25 2.25 2.25-5.25 5.25-2.25Z"/>',
);

export const evaCalendarPlus = outline(`${CALENDAR}<path d="M12 12.75v4.5M9.75 15h4.5"/>`);

export const evaCalendarX = outline(`${CALENDAR}<path d="m10.125 13.125 3.75 3.75m0-3.75-3.75 3.75"/>`);

export const evaCalendarClock = outline(`${CALENDAR}<circle cx="12" cy="15" r="3.375"/><path d="M12 13.5V15h1.5"/>`);

export const evaPlug = outline(
  '<path d="M9 3v4.5M15 3v4.5M6 7.5h12V12a4.5 4.5 0 0 1-4.5 4.5h-3A4.5 4.5 0 0 1 6 12V7.5ZM12 16.5V21"/>',
);

export const evaHourglass = outline(
  '<path d="M6 3h12M6 21h12M7.5 3v3.257a2.25 2.25 0 0 0 .659 1.591L12 12l3.841-4.152A2.25 2.25 0 0 0 16.5 6.257V3M7.5 21v-3.257a2.25 2.25 0 0 1 .659-1.591L12 12l3.841 4.152a2.25 2.25 0 0 1 .659 1.591V21"/>',
);

export const evaMouse = outline('<rect x="6" y="3" width="12" height="18" rx="6"/><path d="M12 6.75v3"/>');

export const evaKeyboard = outline(
  '<rect x="3" y="5.25" width="18" height="13.5" rx="2.25"/><path d="M7.5 9.75h.01M10.5 9.75h.01M13.5 9.75h.01M16.5 9.75h.01M9 12.75h.01M12 12.75h.01M15 12.75h.01M8.25 15.75h7.5"/>',
);

export const evaPin = fromLucide(
  '<path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/>',
);

export const evaFunnelX = fromLucide(
  '<path d="M12.531 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l.427-.473"/><path d="m16.5 3.5 5 5"/><path d="m21.5 3.5-5 5"/>',
);

export const evaHistory = fromLucide(
  '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/>',
);

export const evaHammer = fromLucide(
  '<path d="m15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9"/><path d="m18 15 4-4"/><path d="m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5"/>',
);

export const evaCar = fromLucide(
  '<path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/>',
);

export const evaCrown = fromLucide(
  '<path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/><path d="M5 21h14"/>',
);

export const evaSignpost = fromLucide(
  '<path d="M12 13v8"/><path d="M12 3v3"/><path d="M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z"/>',
);

export const evaUserPen = fromLucide(
  '<path d="M11.5 15H7a4 4 0 0 0-4 4v2"/><path d="M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"/><circle cx="10" cy="7" r="4"/>',
);

export const evaHandshake = fromLucide(
  '<path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3 1 11h-2"/><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/><path d="M3 4h8"/>',
);

// Logos officiels monochromes (Simple Icons, CC0), ramenés au gabarit 3–21 des Heroicons.
const brand = (d: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style="width:var(--ng-icon__size, 1em);height:var(--ng-icon__size, 1em)"><path transform="translate(3 3) scale(0.75)" d="${d}"/></svg>`;

export const evaBrandWhatsapp = brand(
  "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z",
);

export const evaBrandGoogle = brand(
  "M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z",
);

export const evaBrandSlack = brand(
  "M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z",
);

// Microsoft a fait retirer son logo de Simple Icons : quatre carrés aux proportions officielles.
export const evaBrandMicrosoft = brand(
  "M0 0v11.408h11.408V0zm12.594 0v11.408H24V0zM0 12.594V24h11.408V12.594zm12.594 0V24H24V12.594z",
);

/** Icônes maison EVA, à enregistrer comme les Heroicons (`provideIcons` / `withIcons`). */
export const EVA_ICONS = {
  evaSave,
  evaCircle,
  evaCircleFill,
  evaCheckSquare,
  evaSpinner,
  evaFilePdf,
  evaFileExcel,
  evaPercent,
  evaSitemap,
  evaCompass,
  evaCalendarPlus,
  evaCalendarX,
  evaCalendarClock,
  evaFunnelX,
  evaPlug,
  evaHourglass,
  evaMouse,
  evaKeyboard,
  evaPin,
  evaHistory,
  evaHammer,
  evaCar,
  evaCrown,
  evaSignpost,
  evaUserPen,
  evaHandshake,
  evaBrandWhatsapp,
  evaBrandGoogle,
  evaBrandSlack,
  evaBrandMicrosoft,
};
